module.exports = __webpack_public_path__ + "static/media/listDataset.c77c3391.svg";